module.exports = __webpack_public_path__ + "static/media/lynkitid-logo.a9cf944c.png";